/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SiaAdminGuard implements CanActivate {
  constructor() {} // private userStore: UserStore // private roleProvider: NbRoleProvider,

  canActivate(): // route: ActivatedRouteSnapshot,
  // state: RouterStateSnapshot
  Observable<boolean> | Promise<boolean> | boolean {
    // return this.roleProvider.getRole().pipe(
    //   map(role => {
    //     const roles = role instanceof Array ? role : [role];
    //     // let u = this.userStore.getUser();
    //     // if (u) {
    //     //   return ROLES.ADMIN === u.role;
    //     // } else {
    //     return roles.some(x => x && x.toLowerCase() === ROLES.ADMIN);
    //     // }
    return true;
  }
}
